import * as cx from 'classnames';
import * as React from 'react';
import { SvgIcon } from '..';
import * as Styles from './IconButton.scss';

interface IOwnProps {
  icon: 'minus' | 'plus' | 'checkMark' | 'information';
  size?: 'big';
  onClick: (event: React.SyntheticEvent<HTMLButtonElement>) => void;
}
const IconButton: React.SFC<IOwnProps> = (props) => {
  const { icon, size, onClick } = props;

  const priceEachClassNames = cx({
    [Styles.button]: true,
    [Styles.big]: size && size === 'big',
  });

  return (
    <button type="button" className={priceEachClassNames} onClick={onClick}>
      <SvgIcon icon={icon} />
    </button>
  );
};

export default IconButton;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/IconButton/IconButton.tsx